module.exports = __webpack_public_path__ + "static/media/Shift_button.53dfca7f.svg";